var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha",on:{"click":_vm.refreshCaptcha}},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"captcha"}}):_c('div',{staticClass:"loading"},[_vm._v("...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }